module.exports = __webpack_public_path__ + "95273a3080d9f202c9ff69d0ecdddb7c.svg";